import styled from "styled-components";

export const Heading = styled("h1")(({ theme }) => ({
    ...theme.typography.h1,
    margin: 0,
}));

export const SectionTitle = styled("h2")(
    ({ theme, margin, noSpacing, borderColor }) => ({
        ...theme.typography.h2,
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        margin: margin || "0",
        paddingBottom: noSpacing ? "0" : "16px",
        borderBottom: `2px solid ${borderColor || "transparent"}`,
    }),
);

export const Subtitle = styled.h2`
    margin: 6px 0 0 0;
`;

export const ErrorMessage = styled.p`
    color: #ff6654;
    font-size: 14px;
    margin: 7px auto;
`;

export const PageMessage = styled.h2`
    margin: 36px auto;
    text-align: center;
`;
